module.exports = __webpack_public_path__ + "static/media/dubleBg2.5ad23b43.png";